import React from "react";
import LanguageSelector from "../layouts/language";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import LogoText from "../../assets/img/salad_exchange.png";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import Phone from "../../assets/img/phone.png";
import { Button } from "react-bootstrap";
import GoogleEn from "../../assets/img/badge-ps.png";
import GoogleJp from "../../assets/img/badge-ps-jp.png";
import GoogleId from "../../assets/img/badge-ps-id.png";
import { useTranslation } from "../../store/languageSlice/languageHook";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { PhoneOutlined } from "@mui/icons-material";
import {
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";

import FB from "../../assets/img/Facebook.png";
import IG from "../../assets/img/Instagram.png";
import TW from "../../assets/img/Twitter.png";
import YT from "../../assets/img/Youtube.png";
import SendIcon from "@mui/icons-material/Send";

const badgeMap = {
  "en-US": GoogleEn,
  "jp-JP": GoogleJp,
  "id-ID": GoogleId,
};

const COMPANY = {
  name: "PT.Tugboat Trading Indonesia",
  brand: "Sal Ad",
  email: "business@sal-ad.id",
  phone: "021-27089659",
  addressLine1: "Jl. Sultan Hasanuddin Dalam Blok M",
  addressLine2:
    "Melawai, Kec. Kebayoran Baru, Kota Jakarta Selatan, DKI Jakarta 12160",
};

const PrivacyPolicyPage = () => {
  const [sideBar, setSideBar] = React.useState(0);
  const { active: activeLang } = useTranslation();
  const lang = activeLang;

  const lastUpdated = new Date().toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const openSideBarMenu = () => {
    setSideBar(50);
  };

  const closeSideBarMenu = () => {
    setSideBar(0);
  };

  const scrollMenu = (e, hash) => {
    let menu = document.getElementById(hash);
    e.preventDefault();
    menu && menu.scrollIntoView({ behavior: "smooth", block: "start" });
    window.history.pushState(hash, hash, "/");
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  function MenuBar() {
    return (
      <>
        <Link to={"/"} onClick={() => scrollToTop()}>
          {"HOME_NB_1".tr()}
        </Link>
        <Link to={"/"} onClick={(e) => scrollMenu(e, "feature")}>
          {"HOME_NB_2".tr()}
        </Link>
        <Link to={"/"} onClick={(e) => scrollMenu(e, "tutorials")}>
          {"HOME_NB_3".tr()}
        </Link>
        <Link to={"/"} onClick={(e) => scrollMenu(e, "contact")}>
          {"HOME_NB_4".tr()}
        </Link>
      </>
    );
  }

  // A reusable component for section titles for consistency
  const SectionTitle = ({ children }) => (
    <h2 className="text-2xl font-semibold text-neutral-800 border-b pb-2 mb-6">
      {children}
    </h2>
  );

  return (
    <div className="sal-homepage bg-neutral-50">
      {/* Header section remains unchanged to preserve theme */}
      <div
        className="sal-homepage-header"
        style={{
          background: "white",
          marginBottom: "0",
          paddingBottom: "0",
        }}
      >
        <div className="container">
          <div className="sal-homepage-header-container d-none d-md-flex">
            <div className="sal-homepage-header-nav">
              <img src={LogoText} alt={"Sal Ad"} width={160} />
              <MenuBar />
            </div>
            <div className="sal-homepage-header-btn d-flex align-items-center">
              <LanguageSelector />
            </div>
          </div>

          <div className="sal-homepage-header-containermob d-block d-md-none">
            <div className="sal-homepage-header-navmob d-block d-md-none">
              <div className="sal-sidenav" style={{ width: `${sideBar}%` }}>
                <IconButton
                  className="sal-close-button"
                  onClick={() => closeSideBarMenu()}
                >
                  <HighlightOffIcon />
                </IconButton>
                <MenuBar />
              </div>
              <div className="w-100 d-flex align-items-center justify-content-between">
                <img src={LogoText} alt={"Sal Ad"} width={130} />
                <span onClick={() => openSideBarMenu()}>
                  <MenuIcon className="fill-primary" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main content with updated, clean design */}
      <main className="privacy-policy-main mx-auto max-w-4xl px-5 py-20 text-neutral-900">
        <div>
          {/* Page Header */}
          <header className="mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-primary-900">
              {"PRIVACY_POLICY_TITLE".tr()}
            </h1>
            <p className="mt-4 text-sm text-neutral-500">
              {/* {"LAST_UPDATED".tr()} {lastUpdated} */}
              {"LAST_UPDATED".tr()} 19 September 2025
            </p>
            <p className="mt-6 text-lg text-neutral-700 leading-relaxed">
              {"PRIVACY_POLICY_INTRO".tr()}
            </p>
          </header>

          {/* Policy Sections with improved styling */}
          <div className="space-y-12">
            <section id="informasi">
              <SectionTitle>{"POLICY_SECTION_1_TITLE".tr()}</SectionTitle>
              <ul className="list-disc list-inside space-y-3 text-neutral-700 leading-relaxed">
                <li>{"POLICY_SECTION_1_ITEM_1".tr()}</li>
                <li>{"POLICY_SECTION_1_ITEM_2".tr()}</li>
                <li>{"POLICY_SECTION_1_ITEM_3".tr()}</li>
                <li>{"POLICY_SECTION_1_ITEM_4".tr()}</li>
                <li>{"POLICY_SECTION_1_ITEM_5".tr()}</li>
              </ul>
            </section>

            <section id="penggunaan">
              <SectionTitle>{"POLICY_SECTION_2_TITLE".tr()}</SectionTitle>
              <ul className="list-disc list-inside space-y-3 text-neutral-700 leading-relaxed">
                <li>{"POLICY_SECTION_2_ITEM_1".tr()}</li>
                <li>{"POLICY_SECTION_2_ITEM_2".tr()}</li>
                <li>{"POLICY_SECTION_2_ITEM_3".tr()}</li>
                <li>{"POLICY_SECTION_2_ITEM_4".tr()}</li>
                <li>{"POLICY_SECTION_2_ITEM_5".tr()}</li>
                <li>{"POLICY_SECTION_2_ITEM_6".tr()}</li>
              </ul>
            </section>

            <section id="dasar-hukum">
              <SectionTitle>{"POLICY_SECTION_3_TITLE".tr()}</SectionTitle>
              <p className="text-neutral-700 leading-relaxed">
                {"POLICY_SECTION_3_TEXT".tr()}
              </p>
            </section>

            <section id="pembagian">
              <SectionTitle>{"POLICY_SECTION_4_TITLE".tr()}</SectionTitle>
              <p className="mb-4 text-neutral-700 leading-relaxed">
                {"POLICY_SECTION_4_TEXT".tr()}
              </p>
              <ul className="list-disc list-inside space-y-3 text-neutral-700 leading-relaxed">
                <li>{"POLICY_SECTION_4_ITEM_1".tr()}</li>
                <li>{"POLICY_SECTION_4_ITEM_2".tr()}</li>
                <li>{"POLICY_SECTION_4_ITEM_3".tr()}</li>
              </ul>
            </section>

            <section id="keamanan">
              <SectionTitle>{"POLICY_SECTION_5_TITLE".tr()}</SectionTitle>
              <ul className="list-disc list-inside space-y-3 text-neutral-700 leading-relaxed">
                <li>{"POLICY_SECTION_5_ITEM_1".tr()}</li>
                <li>{"POLICY_SECTION_5_ITEM_2".tr()}</li>
                <li>{"POLICY_SECTION_5_ITEM_3".tr()}</li>
              </ul>
            </section>

            <section id="hak">
              <SectionTitle>{"POLICY_SECTION_6_TITLE".tr()}</SectionTitle>
              <ul className="list-disc list-inside space-y-3 text-neutral-700 leading-relaxed">
                <li>{"POLICY_SECTION_6_ITEM_1".tr()}</li>
                <li>{"POLICY_SECTION_6_ITEM_2".tr()}</li>
                <li>{"POLICY_SECTION_6_ITEM_3".tr()}</li>
                <li>{"POLICY_SECTION_6_ITEM_4".tr()}</li>
                <li>{"POLICY_SECTION_6_ITEM_5".tr()}</li>
              </ul>
            </section>

            <section id="cookies">
              <SectionTitle>{"POLICY_SECTION_7_TITLE".tr()}</SectionTitle>
              <p className="text-neutral-700 leading-relaxed">
                {"POLICY_SECTION_7_TEXT".tr()}
              </p>
            </section>

            <section id="retensi">
              <SectionTitle>{"POLICY_SECTION_8_TITLE".tr()}</SectionTitle>
              <p className="text-neutral-700 leading-relaxed">
                {"POLICY_SECTION_8_TEXT".tr()}
              </p>
            </section>

            <section id="privasi-anak">
              <SectionTitle>{"POLICY_SECTION_9_TITLE".tr()}</SectionTitle>
              <p className="text-neutral-700 leading-relaxed">
                {"POLICY_SECTION_9_TEXT".tr()}
              </p>
            </section>

            <section id="transfer-data">
              <SectionTitle>{"POLICY_SECTION_10_TITLE".tr()}</SectionTitle>
              <p className="text-neutral-700 leading-relaxed">
                {"POLICY_SECTION_10_TEXT".tr()}
              </p>
            </section>

            <section id="perubahan">
              <SectionTitle>{"POLICY_SECTION_11_TITLE".tr()}</SectionTitle>
              <p className="text-neutral-700 leading-relaxed">
                {"POLICY_SECTION_11_TEXT".tr()}
              </p>
            </section>

            <div className="mt-5">
              <a
                to={
                  "https://play.google.com/store/apps/details?id=com.saladnet.app"
                }
                target="_blank"
              >
                <img
                  src={badgeMap[lang] || GoogleEn} // fallback to EN
                  alt={"salad-ps"} // alt text from translations
                />
              </a>
            </div>
          </div>
        </div>

        <aside className="table-contents hidden lg:block w-64 shrink-0">
          <nav aria-label="Daftar Isi" className="sticky top-28 border-l pl-4">
            <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-neutral-600">
              {"TOC_TITLE".tr()}
            </h2>
            <ul className="space-y-2 text-sm">
              {[
                ["TOC_SECTION_1".tr(), "informasi"],
                ["TOC_SECTION_2".tr(), "penggunaan"],
                ["TOC_SECTION_3".tr(), "dasar-hukum"],
                ["TOC_SECTION_4".tr(), "pembagian"],
                ["TOC_SECTION_5".tr(), "keamanan"],
                ["TOC_SECTION_6".tr(), "hak"],
                ["TOC_SECTION_7".tr(), "cookies"],
                ["TOC_SECTION_8".tr(), "retensi"],
                ["TOC_SECTION_9".tr(), "privasi-anak"],
                ["TOC_SECTION_10".tr(), "transfer-data"],
                ["TOC_SECTION_11".tr(), "perubahan"],
              ].map(([label, id]) => (
                <li key={id}>
                  <a
                    href={`#${id}`}
                    className="text-primary-700 hover:underline underline-offset-2"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </aside>
      </main>

      <div id="contact" className="sal-homepage-footer">
        <div className="container ps-4 pe-4">
          <div className="row">
            {/* <div className="col-12 col-md-10 mb-3"> */}
            <div className="col-12 mb-3">
              <div className="row gap-5 gap-md-0">
                <div className="col-12 col-md-4">
                  {/* <p className="sal-homepage-footer-title">{"HOME_PRODUCT".tr()}</p> */}
                  <img src={LogoText} alt={"Sal Ad"} width={120} />
                  <p className="sal-homepage-footer-desc mt-3">
                    <span className="mb-2 d-block">
                      PT.Tugboat Trading Indonesia
                    </span>
                    {"ADDRESS_1".tr()}
                    <br />
                    {"ADDRESS_2".tr()}
                    <br />
                    {"ADDRESS_3".tr()}
                  </p>
                  <div className="sal-homepage-footer-contact">
                    <MailOutlineIcon className="fill-muted" />{" "}
                    Business@sal-ad.net
                  </div>
                  <div className="sal-homepage-footer-contact">
                    <PhoneOutlined className="fill-muted" /> 021-27098659
                  </div>

                  {/* <p className="sal-homepage-footer-title">{"HOME_PRODUCT".tr()}</p>
                                          <Button
                                              to={"/"}
                                              variant="link"
                                              className="sal-btn-link-footer"
                                          >
                                              {"HOME_DOCUMENTATIONS".tr()}
                                          </Button>
                                          <Button
                                              to={"/"}
                                              variant="link"
                                              className="sal-btn-link-footer"
                                          >
                                              {"HOME_INTEGRATIONS".tr()}
                                          </Button>
                                          <Button
                                              to={"/"}
                                              variant="link"
                                              className="sal-btn-link-footer"
                                          >
                                              {"HOME_PRICING".tr()}
                                          </Button>
                                          <Button
                                              to={"/"}
                                              variant="link"
                                              className="sal-btn-link-footer"
                                          >
                                              {"HOME_API".tr()}
                                          </Button> */}
                </div>
                <div className="col-12 col-md-2">
                  <p className="sal-homepage-footer-title">
                    {"HOME_COMPANY".tr()}
                  </p>
                  <Button
                    to={"/"}
                    variant="link"
                    className="sal-btn-link-footer"
                  >
                    {"HOME_ABOUT_US".tr()}
                  </Button>
                  <a
                    href={"https://admin.sal-ad.com/auth/login"}
                    variant="link"
                    target="_blank"
                    className="sal-btn-link-footer"
                  >
                    {"HOME_ACCESS_PARTNERS".tr()}
                  </a>
                  {/* <Button
                                              to={"/"}
                                              variant="link"
                                              className="sal-btn-link-footer"
                                          >
                                              {"HOME_CAREERS".tr()}
                                          </Button> */}
                </div>
                <div className="col-12 col-md-2">
                  <p className="sal-homepage-footer-title">
                    {"HOME_SUPPORT".tr()}
                  </p>
                  <Button
                    to={"/"}
                    variant="link"
                    className="sal-btn-link-footer"
                  >
                    {"HOME_KNOWLEDGE".tr()}
                  </Button>
                  <Button
                    to={"/"}
                    variant="link"
                    className="sal-btn-link-footer"
                  >
                    {"HOME_TUTORIALS".tr()}
                  </Button>
                  <Button
                    to={"/"}
                    variant="link"
                    className="sal-btn-link-footer"
                  >
                    {"HOME_DOCUMENTS".tr()}
                  </Button>
                  <Button
                    to={"/"}
                    variant="link"
                    className="sal-btn-link-footer"
                  >
                    {"HOME_GUIDELINES".tr()}
                  </Button>
                </div>
                <div className="col-12 col-md-4">
                  <p className="sal-homepage-footer-title">
                    {"HOME_STAYUPTODATE".tr()}
                  </p>
                  <p className="sal-homepage-footer-desc">
                    {"HOME_SUBSCRIBE".tr()}
                  </p>
                  <FormControl variant="outlined" fullWidth>
                    <OutlinedInput
                      type="text"
                      name="bsaMail"
                      placeholder={"Enter email"}
                      className="sal-form-email"
                      startAdornment={
                        <InputAdornment position="start">
                          <MailOutlineIcon className="fill-muted" />
                        </InputAdornment>
                      }
                      endAdornment={
                        <InputAdornment position="end">
                          <Button variant="primary">
                            <SendIcon className="fill-white" />
                          </Button>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>
              </div>
            </div>
            {/* <div className="col-12 col-md-5">
                                  <div className="row">
                                      <div className="col-12 col-md-6 mb-5">
                                          <p className="sal-homepage-footer-title">{"HOME_CONTACT_US".tr()}</p>
                                          <p className="sal-homepage-footer-desc">
                                              Plaza Indonesia, Level 5, Unit E021AB
                                              <br />
                                              Jl. M.H Thamrin Kavling 28-30
                                              <br />
                                              Kel. Gondangdia, Kec. Menteng,
                                              <br />
                                              Jakarta Pusat 10350
                                          </p>
                                          <p className="sal-homepage-footer-desc mb-0">
                                              {"HOME_EMAIL_CONTACT_US".tr()}
                                          </p>
                                      </div>
                                      <div className="col-12 col-md-6">
                                          <p className="sal-homepage-footer-title">{"HOME_STAYUPTODATE".tr()}</p>
                                          <p className="sal-homepage-footer-desc">
                                              {"HOME_SUBSCRIBE".tr()}
                                          </p>
                                          <FormControl variant="outlined" fullWidth>
                                              <OutlinedInput
                                                  type="text"
                                                  name="bsaMail"
                                                  placeholder={"HOME_ENTER_EMAIL".tr()}
                                                  className="sal-form-email"
                                                  startAdornment={
                                                      <InputAdornment position="start">
                                                          <MailOutlineIcon className="fill-muted" />
                                                      </InputAdornment>
                                                  }
                                                  endAdornment={
                                                      <InputAdornment position="end">
                                                          <Button variant="primary">
                                                              <SendIcon className="fill-white" />
                                                          </Button>
                                                      </InputAdornment>
                                                  }
                                              />
                                          </FormControl>
                                      </div>
                                  </div>
                              </div> */}
          </div>
        </div>
        <div className="sal-break-line"></div>
        <div className="container">
          <div className="row align-items-center justify-content-between">
            {/* Desktop View */}
            <div className="col-md-2 d-none d-md-block">
              <img src={LogoText} alt={"Sal Ad"} width={120} />
            </div>
            {/* Mobile View */}
            <div className="col-12 d-block d-md-none mb-4" align="center">
              <img src={LogoText} alt={"Sal Ad"} width={160} />
            </div>
            <div className="col-12 col-md-8">
              <p className="sal-copyright mb-0 text-center">
                © 2022 SalAd All rights reserved.
              </p>
              <div className="d-block d-md-none mb-4"></div>
            </div>
            {/* Desktop View */}
            <div className="col-md-2 d-none d-md-block">
              <div className="d-flex align-items-center justify-content-between">
                <Link to={"/"} alt="Social Media" className="me-3">
                  <img src={FB} alt={"Socmed"} width={24} />
                </Link>
                <Link to={"/"} alt="Social Media" className="me-3">
                  <img src={IG} alt={"Socmed"} width={24} />
                </Link>
                <Link to={"/"} alt="Social Media" className="me-3">
                  <img src={TW} alt={"Socmed"} width={24} />
                </Link>
                <Link to={"/"} alt="Social Media">
                  <img src={YT} alt={"Socmed"} width={24} />
                </Link>
              </div>
            </div>
            {/* Desktop View */}
            <div className="col-6 d-block d-md-none mx-auto">
              <div className="d-flex align-items-center justify-content-between">
                <Link to={"/"} alt="Social Media" className="me-3">
                  <img src={FB} alt={"Socmed"} width={24} />
                </Link>
                <Link to={"/"} alt="Social Media" className="me-3">
                  <img src={IG} alt={"Socmed"} width={24} />
                </Link>
                <Link to={"/"} alt="Social Media" className="me-3">
                  <img src={TW} alt={"Socmed"} width={24} />
                </Link>
                <Link to={"/"} alt="Social Media">
                  <img src={YT} alt={"Socmed"} width={24} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
